import { useMemo } from "react";
import { firstBy } from "thenby";

import type { CardType, VariantType } from "~/types/card";
import type { DeckCardType } from "~/types/deck";
import { DecklistItem } from "./DecklistItem";

type Props = {
  title?: string;
  cards: DeckCardType[];
  onCardHover?: (squiggle: { card: CardType; variant: VariantType }) => void;
};

export const DecklistSection = ({ onCardHover, cards, title }: Props) => {
  const sortedCards = useMemo(
    // todo check this doesnt already happen on the server
    () =>
      cards.sort(
        firstBy((c: DeckCardType) => c.card.guardian?.cost ?? 0).thenBy((c) => c.card.name),
      ),
    [cards],
  );

  return (
    <div className="mb-4 break-inside-avoid">
      {title && (
        <div className="mx-[2px] mb-1 border-b border-b-line-color p-1 pb-2 text-left">
          <span className="capitalize">{title} </span>
          <span>(</span>
          {cards.reduce((a, c) => a + c.quantity, 0)}
          <span>)</span>
        </div>
      )}

      {sortedCards.map((dc) => (
        <DecklistItem deckCard={dc} onCardHover={onCardHover} key={dc.id} />
      ))}
    </div>
  );
};
